export default __webpack_public_path__ + "static/media/Varsha MC.161d3736.jpg";